module.exports = __webpack_public_path__ + "static/the-mountains-sing-215337b31c760cd127ac137ede248ee2.jpg";